module.exports = __webpack_public_path__ + "static/img/yytx16.1c7a584.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/yytx16.png
// module id = 796
// module chunks = 0